// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profileresearch_container_research__yl4WB {
 
  display: flex;
  flex:  5 1;
  flex-direction: column;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
}


.profileresearch_research_navigation_bar__-wuW4 {
  vertical-align: "top";
  padding-right: 5%; 
  display: flex; 
  flex: 1 1; 
  flex-direction: column; 
  align-content: flex-start;
  align-items: center;
  align-self: flex-start;}

.profileresearch_research_content__74ehM {
  vertical-align: "top";
  width: 70%;
margin-left: 5%; 
  display: flex; 
  flex: 8 1; 
  flex-direction: column; 
  align-content: baseline;
  align-items: left;
  align-self: center; }



.profileresearch_divider__Lw\\+MU {
  width: 100%;
  height: 0px;
  margin-top: 15px;
  margin-bottom: 15px;
  border: 1px solid var(--hsrcLightDark); }

.profileresearch_text16px__bcDHC {
  font-family: var(--FontFamily);
  font-size: 26px;
  color: var(--hsrcDarkBlue);
}

.profileresearch_text18pxOrange__7fYMy {
  font-family: var(--FontFamily);
  font-size: 18px;
  color: var(--hsrcOrange);
}




`, "",{"version":3,"sources":["webpack://./src/pages/RespondentDashboard/pages/Research/profileresearch.module.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,UAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;AACrB;;;AAGA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB,CAAC;;AAEzB;EACE,qBAAqB;EACrB,UAAU;AACZ,eAAe;EACb,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB,EAAE;;;;AAItB;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC,EAAE;;AAE1C;EACE,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,wBAAwB;AAC1B","sourcesContent":[".container_research {\r\n \r\n  display: flex;\r\n  flex:  5;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: center;\r\n  justify-content: center;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n}\r\n\r\n\r\n.research_navigation_bar {\r\n  vertical-align: \"top\";\r\n  padding-right: 5%; \r\n  display: flex; \r\n  flex: 1; \r\n  flex-direction: column; \r\n  align-content: flex-start;\r\n  align-items: center;\r\n  align-self: flex-start;}\r\n\r\n.research_content {\r\n  vertical-align: \"top\";\r\n  width: 70%;\r\nmargin-left: 5%; \r\n  display: flex; \r\n  flex: 8; \r\n  flex-direction: column; \r\n  align-content: baseline;\r\n  align-items: left;\r\n  align-self: center; }\r\n\r\n\r\n\r\n.divider {\r\n  width: 100%;\r\n  height: 0px;\r\n  margin-top: 15px;\r\n  margin-bottom: 15px;\r\n  border: 1px solid var(--hsrcLightDark); }\r\n\r\n.text16px {\r\n  font-family: var(--FontFamily);\r\n  font-size: 26px;\r\n  color: var(--hsrcDarkBlue);\r\n}\r\n\r\n.text18pxOrange {\r\n  font-family: var(--FontFamily);\r\n  font-size: 18px;\r\n  color: var(--hsrcOrange);\r\n}\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_research": `profileresearch_container_research__yl4WB`,
	"research_navigation_bar": `profileresearch_research_navigation_bar__-wuW4`,
	"research_content": `profileresearch_research_content__74ehM`,
	"divider": `profileresearch_divider__Lw+MU`,
	"text16px": `profileresearch_text16px__bcDHC`,
	"text18pxOrange": `profileresearch_text18pxOrange__7fYMy`
};
export default ___CSS_LOADER_EXPORT___;
